import { getCommon } from 'app-lib/assetUtils'
import React from 'react'
import { Icon, Loader, InfoTip } from 'ui-framework'
import { autoFormat } from 'app-lib/numberUtils'
import { observer } from 'mobx-react'
import { StatsStore } from 'bzx-common/src/stores'
import treasuryImg from './treasury.svg'
import { links } from 'bzx-common/src/config/appConfig'
import ExternalLink from 'shared-components/ExternalLink'
import Placeholder from 'shared-components/Placeholder'

const vbzrxTip = (
  <InfoTip id="tip-treasury-vooki">
    {'vBZRX are tokens that are "vesting" over time. They are converted to OOKI little by little.'}
  </InfoTip>
)

export const Treasury = ({ statsStore }: { statsStore: StatsStore }) => {
  const { treasuryBalances, treasuryTotalUsd } = statsStore
  return (
    <div className="treasury">
      <div className="txt-center">
        <img className="treasury__gnome" src={treasuryImg} />
        <div className="margin-v-2">
          <h3 className="h3">Total in DAO treasury</h3>
          {treasuryTotalUsd.isNaN() ? (
            <Placeholder small />
          ) : (
            <div className="txt-size-2">${autoFormat(treasuryTotalUsd)}</div>
          )}
        </div>
      </div>

      <div>
        <div className="panel--simple md-padded-2">
          <h3 className="title-section">Treasury balances</h3>
          <div>
            {treasuryBalances.value.length === 0 && treasuryBalances.pending && (
              <Loader quantityDots={3} sizeDots="small" />
            )}
            {treasuryBalances.error && (
              <p className="txt-warning">The balances could not be loaded</p>
            )}
            {treasuryBalances.value
              .filter((balance) => balance.amountUSD.gt(0.1))
              .map((balance) => {
                const { displayName, spriteLogo } = getCommon(balance.asset)
                return (
                  <div key={displayName}>
                    <div className="flex-row-center margin-bottom-2">
                      <Icon size={32} name={spriteLogo} className="margin-right-05" />{' '}
                      <span className="txt-alternate margin-right-05">{displayName}</span>
                      <span className="txt-title" title={balance.amount.toString()}>
                        {autoFormat(balance.amount)}
                      </span>{' '}
                      <div className="flex-row-end txt-right">
                        <div className="txt-title txt-muted" title={balance.amountUSD.toString()}>
                          ${autoFormat(balance.amountUSD)}
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
        <div className="txt-explanation margin-top-1">
          <div className="flex-between">
            <ExternalLink className="link--discreet" href={links.daoTreasury}>
              Treasury address
            </ExternalLink>
            <div>What are vBZRX? {vbzrxTip}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default observer(Treasury)
